import { memo } from "react";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {
    OnboardingApplicationStep,
    OnboardingApplication,
    ECommerceOnboardingApplication,
    onboardingApplicationStepAndFieldStatus
} from "consts/onboarding";
import {
    StepLabel,
    useApplicationDetailContext,
    type StepLabelProps
} from "ui/organizms/Onboarding/Applications/common";

const BankingAndFinanceLabel = (props: Partial<StepLabelProps>) => {
    const { getStepData } = useApplicationDetailContext();

    const data = getStepData(ECommerceOnboardingApplication.BillingFinance);

    return (
        <StepLabel
            to={`${OnboardingApplicationStep[OnboardingApplication.ECommerce].BankingAndFinance}`}
            Icon={AccountBalanceIcon}
            {...onboardingApplicationStepAndFieldStatus.get(data.status)}
            {...props}
        >
            Banking & Finance
        </StepLabel>
    );
};

export default memo(BankingAndFinanceLabel);
